export enum FontWeights {
  Regular = 400,
  Bold = 600,
}
